/**
 * Task refs with a project prefix (SF-T-12, T-25) in comments and descriptions link to that task, in
 * whichever project has the prefix. Plain T-12 stays text: older text uses it for other boards' tasks.
 * Upper case only, so words like "re-t-2" aren't taken for refs.
 */
const TASK_REF_RE = /(?<![A-Za-z0-9-])([A-Z]{2})-T-(\d{1,9})(?![A-Za-z0-9])/g;

export interface TaskRefRange {
  start: number;
  end: number;
  prefix: string;
  number: number;
}

/** Where the prefixed task refs are in a run of text. */
export function taskRefRanges(text: string): TaskRefRange[] {
  return [...text.matchAll(TASK_REF_RE)].map((m) => ({
    start: m.index!,
    end: m.index! + m[0].length,
    prefix: m[1],
    number: Number(m[2]),
  }));
}

export function hasTaskRefs(text: string): boolean {
  return taskRefRanges(text).length > 0;
}
